<template lang="pug">
.profile-block(
    v-if="user"
)
    SvIcon.profile-block__avatar(
        icon="profile"
        :width="60"
        :height="60"
    )

    .profile-block__info
        .ptofile-block__title
            .profile-block__name
                | {{ user.name }}

            .profile-block__surname
                | {{ user.surname }}

        button.profile-block__logout(
            @click="logout"
        )
            | Выйти
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'Profile',

  components: {
    SvIcon,
  },

  computed: {
      user () {
          return this.$store.state.user.user;
      }
  },

  methods: {
      async logout () {
          await this.$store.dispatch('user/logout');
          this.$router.push({ name: 'auth' });
      }
  }
};
</script>

<style lang="scss" scoped>
.profile-block {
    background-color: rgba(255, 255, 255, .25);
    border-radius: 100px;
    padding: 10px;
    display: flex;
    font-weight: bold;
    color: #fff;

    &__avatar {
        margin-right: 4px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
    }

    &__title {
        line-height: 1.1;
    }

    &__info {
        margin-left: 11px;
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: flex-start;
    }

    &__logout {
        background: none;
        color: #086CB5;
        cursor: pointer;
        font-weight: bold;
        border: 0;
        padding: 0;
        outline: none;
        border-bottom: 1px solid transparent;

        &:hover {
            border-bottom: 1px solid rgba(8, 108, 181, .5);
        }
    }
}
</style>
